export default __webpack_public_path__ + "static/media/arrow-down.d6c8b8cb.gif";